/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AgentDto } from './AgentDto';
import {
    AgentDtoFromJSON,
    AgentDtoFromJSONTyped,
    AgentDtoToJSON,
    AgentDtoToJSONTyped,
} from './AgentDto';
import type { CompsPreferencesDto } from './CompsPreferencesDto';
import {
    CompsPreferencesDtoFromJSON,
    CompsPreferencesDtoFromJSONTyped,
    CompsPreferencesDtoToJSON,
    CompsPreferencesDtoToJSONTyped,
} from './CompsPreferencesDto';
import type { PropertyDto } from './PropertyDto';
import {
    PropertyDtoFromJSON,
    PropertyDtoFromJSONTyped,
    PropertyDtoToJSON,
    PropertyDtoToJSONTyped,
} from './PropertyDto';

/**
 * 
 * @export
 * @interface CMADto
 */
export interface CMADto {
    /**
     * 
     * @type {string}
     * @memberof CMADto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof CMADto
     */
    estimatedPriceMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CMADto
     */
    estimatedPriceMax?: number;
    /**
     * 
     * @type {AgentDto}
     * @memberof CMADto
     */
    agent: AgentDto;
    /**
     * 
     * @type {PropertyDto}
     * @memberof CMADto
     */
    subjectProperty: PropertyDto;
    /**
     * 
     * @type {Array<PropertyDto>}
     * @memberof CMADto
     */
    comparableProperties: Array<PropertyDto>;
    /**
     * 
     * @type {Date}
     * @memberof CMADto
     */
    listDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CMADto
     */
    actionedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CMADto
     */
    requestedDate?: Date;
    /**
     * 
     * @type {CompsPreferencesDto}
     * @memberof CMADto
     */
    preferences?: CompsPreferencesDto;
    /**
     * 
     * @type {string}
     * @memberof CMADto
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof CMADto
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof CMADto
     */
    isArchived: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CMADto
     */
    hasUnpublishedChanges: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CMADto
     */
    canPublish: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CMADto
     */
    canCustomize: boolean;
    /**
     * 
     * @type {string}
     * @memberof CMADto
     */
    clientDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof CMADto
     */
    coverPhotoCdnUrl?: string;
    /**
     * Which kind of presentation was chosen during creation
     * @type {string}
     * @memberof CMADto
     */
    presentationType: string;
    /**
     * Most recent date that the CMA updated
     * @type {Date}
     * @memberof CMADto
     */
    updateDate: Date;
}

/**
 * Check if a given object implements the CMADto interface.
 */
export function instanceOfCMADto(value: object): value is CMADto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('agent' in value) || value['agent'] === undefined) return false;
    if (!('subjectProperty' in value) || value['subjectProperty'] === undefined) return false;
    if (!('comparableProperties' in value) || value['comparableProperties'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('isArchived' in value) || value['isArchived'] === undefined) return false;
    if (!('hasUnpublishedChanges' in value) || value['hasUnpublishedChanges'] === undefined) return false;
    if (!('canPublish' in value) || value['canPublish'] === undefined) return false;
    if (!('canCustomize' in value) || value['canCustomize'] === undefined) return false;
    if (!('clientDisplayName' in value) || value['clientDisplayName'] === undefined) return false;
    if (!('presentationType' in value) || value['presentationType'] === undefined) return false;
    if (!('updateDate' in value) || value['updateDate'] === undefined) return false;
    return true;
}

export function CMADtoFromJSON(json: any): CMADto {
    return CMADtoFromJSONTyped(json, false);
}

export function CMADtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CMADto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'estimatedPriceMin': json['estimatedPriceMin'] == null ? undefined : json['estimatedPriceMin'],
        'estimatedPriceMax': json['estimatedPriceMax'] == null ? undefined : json['estimatedPriceMax'],
        'agent': AgentDtoFromJSON(json['agent']),
        'subjectProperty': PropertyDtoFromJSON(json['subjectProperty']),
        'comparableProperties': ((json['comparableProperties'] as Array<any>).map(PropertyDtoFromJSON)),
        'listDate': json['listDate'] == null ? undefined : (new Date(json['listDate'])),
        'actionedDate': json['actionedDate'] == null ? undefined : (new Date(json['actionedDate'])),
        'requestedDate': json['requestedDate'] == null ? undefined : (new Date(json['requestedDate'])),
        'preferences': json['preferences'] == null ? undefined : CompsPreferencesDtoFromJSON(json['preferences']),
        'status': json['status'],
        'title': json['title'],
        'isArchived': json['isArchived'],
        'hasUnpublishedChanges': json['hasUnpublishedChanges'],
        'canPublish': json['canPublish'],
        'canCustomize': json['canCustomize'],
        'clientDisplayName': json['clientDisplayName'],
        'coverPhotoCdnUrl': json['coverPhotoCdnUrl'] == null ? undefined : json['coverPhotoCdnUrl'],
        'presentationType': json['presentationType'],
        'updateDate': (new Date(json['updateDate'])),
    };
}

export function CMADtoToJSON(json: any): CMADto {
    return CMADtoToJSONTyped(json, false);
}

export function CMADtoToJSONTyped(value?: CMADto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'estimatedPriceMin': value['estimatedPriceMin'],
        'estimatedPriceMax': value['estimatedPriceMax'],
        'agent': AgentDtoToJSON(value['agent']),
        'subjectProperty': PropertyDtoToJSON(value['subjectProperty']),
        'comparableProperties': ((value['comparableProperties'] as Array<any>).map(PropertyDtoToJSON)),
        'listDate': value['listDate'] == null ? undefined : ((value['listDate']).toISOString()),
        'actionedDate': value['actionedDate'] == null ? undefined : ((value['actionedDate']).toISOString()),
        'requestedDate': value['requestedDate'] == null ? undefined : ((value['requestedDate']).toISOString()),
        'preferences': CompsPreferencesDtoToJSON(value['preferences']),
        'status': value['status'],
        'title': value['title'],
        'isArchived': value['isArchived'],
        'hasUnpublishedChanges': value['hasUnpublishedChanges'],
        'canPublish': value['canPublish'],
        'canCustomize': value['canCustomize'],
        'clientDisplayName': value['clientDisplayName'],
        'coverPhotoCdnUrl': value['coverPhotoCdnUrl'],
        'presentationType': value['presentationType'],
        'updateDate': ((value['updateDate']).toISOString()),
    };
}

